import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=034fd330&scoped=true&lang=pug&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=034fd330&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.5_snackhrvn2skq2fk5zrw2w5ryi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034fd330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cj/Documents/Work/the-wedding/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034fd330')) {
      api.createRecord('034fd330', component.options)
    } else {
      api.reload('034fd330', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=034fd330&scoped=true&lang=pug&", function () {
      api.rerender('034fd330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/loading.vue"
export default component.exports